
export default "/assets/no-symbol-mini.74408df8.svg"